<div class="bead-list-item-container">
  <div class="bead-container" [class.bead-container-small]="beadSize === 'small'" [class.bead-container-large]="beadSize === 'large'">
    <div
      class="bead-image-palette"
      [ngClass]="{
        'bead-metallic': bead.paletteTypeId === 2,
        'bead-crystal': bead.paletteTypeId === 3,
        'bead-transparent': bead.paletteTypeId === 4,
        'bead-opaque': bead.paletteTypeId === 5,
        'bead-galvanized': bead.paletteTypeId === 6
      }"
      [ngStyle]="{ 'background-color': '#' + bead.beadColor }"
      [appBeadPreview]="bead"
      [previewPaletteId]="bead.paletteId"
    ></div>
    <div class="bead-letter" *ngIf="showLetter && bead.letter">{{ bead.letter }}</div>
  </div>
  <div class="bead-info">
    <strong class="bead-name">
      {{ bead.beadName }}
      <span class="bead-count" *ngIf="showCount && bead.count">({{ bead.count }})</span>
    </strong>
    <small class="bead-description" *ngIf="showDescription && bead.description">
      {{ bead.description }}
    </small>
  </div>
</div>
